





import { computed, defineComponent, toRefs } from '@vue/composition-api';

/**
 * 统一的icon组件加载
 */
export default defineComponent({
  name: 'BaseIcon',
  props: {
    type: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: () => '0',
    },
    className: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { type, size, className } = toRefs(props);
    const iconName = computed(() => `#icon-${type.value}`);
    const iconClass = computed(() =>
      size.value === '0' ? `${className.value}` : `icon-${size.value} ${className.value}`,
    );
    return {
      iconName,
      iconClass,
    };
  },
});
